
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProductsSection from '@/components/ProductsSection';

const Products = () => {
  const { language } = useLanguage();
  
  const pageTitle = language === 'en' ? 'Products | Attaboy Intelligence' : 'Produits | Attaboy Intelligence Artificielle';
  const pageDescription = language === 'en' 
    ? 'Explore our AI-powered tools and solutions designed to transform your business operations.' 
    : 'Explorez nos outils et solutions alimentés par l\'IA conçus pour transformer les opérations de votre entreprise.';

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="pt-24">
          <div className="container mx-auto px-4 py-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
              {language === 'en' ? 'Our Products' : 'Nos Produits'}
            </h1>
          </div>
          <ProductsSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Products;
